export default "__VITE_ASSET__Bxc5t_B8__"